import React from "react";
import { Link } from "react-router-dom";
interface Title {
  title: string;
  link?: string;
  centered?: boolean;
  showAll?: boolean;
  // Optional small uppercase eyebrow line rendered above the main title.
  // Adds editorial rhythm to home sections ("OPEN NOW" / "FEATURED", etc.).
  kicker?: string;
}
const CustomTitle: React.FC<Title> = ({
  title,
  link = "/",
  centered,
  showAll,
  kicker,
}) => {
  return (
    <div
      className={`d-flex align-items-center customTitle pb-3 px-0 gap-2 ${
        centered ? "justify-content-center" : "justify-content-between"
      }`}
    >
      <div className={centered ? "text-center" : "customTitle__block"}>
        {kicker && <span className="customTitle__kicker">{kicker}</span>}
        <h2 className="text-center mb-0">{title}</h2>
      </div>
      {showAll ? (
        <Link
          to={link}
          className="flex-shrink-0 d-inline-flex align-items-center gap-1"
        >
          <span>View all</span>
          <i className="bi bi-chevron-right" aria-hidden="true"></i>
        </Link>
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomTitle;
